import '../styles/main.sass';

const Layout = ({ children }) => {
  return children;
};

export default Layout;
